/**
 * Internal dependencies
 */

import { makeLayout, render } from 'lib/controller';

import { index } from './controller';
import { sidebar } from '../controller';

export default (router) => {
    router(`/resources`, sidebar, index, makeLayout, render);
};